import React from 'react';

const StatCard = ({ 
  title, 
  value, 
  icon, 
  change, 
  changeType, 
  description,
  isLoading = false
}) => {
  // Determine the color class for the change indicator
  const getChangeColorClass = () => {
    if (changeType === 'increase') return 'text-green-600';
    if (changeType === 'decrease') return 'text-red-600';
    return 'text-gray-600';
  };

  // Determine the change prefix (+ or -)
  const getChangePrefix = () => {
    if (changeType === 'increase') return '+';
    if (changeType === 'decrease') return '-';
    return '';
  };

  return (
    <div className="stat-card">
      <div className="flex justify-between items-start">
        <div>
          <h3 className="stat-title">{title}</h3>
          <div className={`stat-value ${isLoading ? 'animate-pulse bg-gray-200 h-8 w-24 rounded' : ''}`}>
            {isLoading ? '' : value}
          </div>
          {description && (
          <div className="stat-description">
            {description}
          </div>
        )}
        </div>
        
        {icon && (
          <div className="stat-icon">
            {icon()}
          </div>
        )}
      </div>
      
      <div className="stat-meta">
        {change && (
          <span className={`stat-change ${getChangeColorClass()}`}>
            {getChangePrefix()}{change}
          </span>
        )}
      </div>
    </div>
  );
};

export default StatCard; 